import React, { useEffect } from "react";

interface PageHelmetProps {
  pageTitle?: string;
}

// Page metadata without react-helmet (unmaintained; its react-side-effect
// dependency caps React at 18). React 19 hoists <meta> rendered here into
// <head>. The title is set on document.title, as react-helmet did: a hoisted
// <title> would land after index.html's own <title>, and browsers use the first.
const PageHelmet: React.FC<PageHelmetProps> = ({ pageTitle }) => {
  useEffect(() => {
    document.title = `${pageTitle} || CEM`;
  }, [pageTitle]);

  return (
    <>
      <meta charSet="utf-8" />
      <meta name="description" content="Cultural Ecologies of Memory by Ricardo Velasco" />
      <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
    </>
  );
};

export default PageHelmet;
